import { render, staticRenderFns } from "./settlement-detailed-list-store.vue?vue&type=template&id=84c316ba&scoped=true"
import script from "./settlement-detailed-list-store.vue?vue&type=script&lang=js"
export * from "./settlement-detailed-list-store.vue?vue&type=script&lang=js"
import style0 from "./settlement-detailed-list-store.vue?vue&type=style&index=0&id=84c316ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c316ba",
  null
  
)

export default component.exports